const bemGenerator = require('./src/bem-generator');
const urlGenerator = require('./src/url-generator');
const vars = require('./styles/settings/variables');
const media = require('./styles/variables').media;
const layout = require('./styles/variables').layout;
const breakpoints = require('./styles/variables').breakpoints;
const remCalc = require('./styles/variables').remCalc;
const pixelCalc = require('./styles/variables').pixelCalc;
const colors = require('./styles/variables').colors;
const colorUtils = require('./src/color-utils');
const animationUtils = require('./src/animation-utils');
const animations = require('./src/animations');
const styledUtils = require('./src/styled-utils');
const browserSupports = require('./src/browser-support').default;
const defaultTheme = require('./styles/themes/default').default;
const darkTheme = require('./styles/themes/dark').default;
const StyledTheme = require('./styles/styled-theme').default;

module.exports = {
  bemGenerator,
  urlGenerator,
  colors,
  campaignColors: vars.campaignColors,
  brandColors: vars.brandColors,
  ratingStarColors: vars.ratingStarColors,
  noop: () => {},
  media,
  layout,
  breakpoints,
  remCalc,
  pixelCalc,
  colorUtils,
  animationUtils,
  animations,
  styledUtils,
  browserSupports,
  defaultTheme,
  darkTheme,
  StyledTheme,
};
